import React from 'react'
import ButtonExternalAuthOption from 'components/button-external-auth-option'
import {
  useExternalLogin,
  LOGO_GOOGLE,
  LOGO_MICROSOFT,
  LOGO_LEX
} from 'utils/hooks/use-external-login'
import type { MoreLoginOptionsProps } from './MoreLoginOptions.types'
import {
  ButtonWrapper,
  Header,
  WelcomeText,
  Wrapper
} from './MoreLoginOptions.style'
import { Button } from '@arvoreeducacao/bonsai-ds'

const MoreLoginOptions: React.FC<MoreLoginOptionsProps> = ({
  closeSection
}) => {
  const { loginWithGoogle, loginWithMicrosoft, loginWithLex } =
    useExternalLogin()

  return (
    <Wrapper>
      <Header>
        <Button
          onClick={closeSection}
          iconName="arrow-left"
          isLeft
          theme={{ type: 'ghost', size: 'medium' }}
          text="Voltar"
          style={{ justifyContent: 'flex-start' }}
        />
        <WelcomeText>Outros métodos de acesso</WelcomeText>
      </Header>
      <ButtonWrapper>
        <ButtonExternalAuthOption
          onClick={loginWithGoogle}
          text="Entrar com Google"
          icon={LOGO_GOOGLE}
        />
        <ButtonExternalAuthOption
          onClick={loginWithMicrosoft}
          text="Entrar com Microsoft"
          icon={LOGO_MICROSOFT}
        />
        <ButtonExternalAuthOption
          onClick={loginWithLex}
          text="Entrar com Lex"
          icon={LOGO_LEX}
        />
      </ButtonWrapper>
    </Wrapper>
  )
}

export default MoreLoginOptions
